const CACHE_META_KEY = 'nlims_cache_meta';
const CACHE_META_EVENT = 'nlims:cache-meta-changed';

function getStorage() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage;
  } catch {
    return null;
  }
}

function readMeta() {
  const storage = getStorage();
  if (!storage) return {};

  try {
    const raw = storage.getItem(CACHE_META_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeMeta(meta) {
  const storage = getStorage();
  if (!storage) return;

  try {
    storage.setItem(CACHE_META_KEY, JSON.stringify(meta));
  } catch {
    // Best-effort cache only.
  }
}

function notifyMetaChange(meta) {
  if (typeof window === 'undefined') return;

  try {
    window.dispatchEvent(new CustomEvent(CACHE_META_EVENT, { detail: meta }));
  } catch {
    // Ignore environments that cannot dispatch custom events.
  }
}

export function readCacheMeta() {
  return readMeta();
}

export function writeCacheMeta(nextMeta = {}) {
  const meta = {
    ...readMeta(),
    ...nextMeta,
  };

  writeMeta(meta);
  notifyMetaChange(meta);
  return meta;
}

export function markCacheSeeded(extra = {}) {
  return writeCacheMeta({
    ...extra,
    lastCached: new Date().toISOString(),
  });
}

export function getCacheMetaEventName() {
  return CACHE_META_EVENT;
}

